// 找到上一个有子元素的1级的最后子元素
function findFunc (list, featIndex, prev = true, funcIndex) {
  let feat
  // 前
  if (prev) {
    if (featIndex === 0) {
      return {
        featIndex: 0,
        funcIndex: funcIndex
      }
    }
    featIndex -= 1
    feat = list[featIndex]
    if (feat.functions.length === 0) {
      return findFunc(list, featIndex, prev, funcIndex)
    }
    return {
      featIndex,
      funcIndex: feat.functions.length - 1
    }
  // 后
  } else {
    if (featIndex === list.length - 1) {
      return {
        featIndex: featIndex,
        funcIndex: funcIndex
      }
    }
    featIndex += 1
    feat = list[featIndex]
    if (feat.functions.length === 0) {
      return findFunc(list, featIndex, prev, funcIndex)
    }
    return {
      featIndex,
      funcIndex: feat.functions.length ? 0 : -1
    }
  }
}
export const up = (list, featIndex, funcIndex) => {
  let feat = null
  let func = null
  let selectItem = {}
  if (featIndex === -1) {
    return {
      feat,
      func,
      selectItem
    }
  }
  feat = list[featIndex]
  if (feat) {
    func = feat.functions[funcIndex]
  }
  if (feat && !func) {
    featIndex = Math.max(0, featIndex - 1)
    selectItem = list[featIndex]
    feat = selectItem
  } else if (func) {
    funcIndex = Math.max(-1, funcIndex - 1)
    if (funcIndex === -1) {
      let result = findFunc(list, featIndex, true, funcIndex)
      funcIndex = result.funcIndex
      featIndex = result.featIndex
      feat = list[featIndex]
    }
    if (feat) {
      func = feat.functions[funcIndex]
    }
    selectItem = func
  }
  return {
    feat,
    func,
    selectItem,
    featIndex,
    funcIndex
  }
}

export const down = (list, featIndex, funcIndex) => {
  let feat = list[featIndex]
  let func = list[featIndex].functions[funcIndex]
  let selectItem = {}
  if (featIndex === list.length - 1) {
    feat = list[featIndex]
    if (funcIndex === -1 || funcIndex === feat.functions.length - 1) {
      return {
        feat,
        func,
        selectItem,
        featIndex,
        funcIndex
      }
    }
  }
  if (feat) {
    func = feat.functions[funcIndex]
  }
  if (feat && !func) {
    featIndex = Math.min(list.length - 1, featIndex + 1)
    selectItem = list[featIndex]
    feat = selectItem
  } else if (func) {
    funcIndex = Math.min(feat.functions.length, funcIndex + 1)
    if (funcIndex === feat.functions.length) {
      let result = findFunc(list, featIndex, false, funcIndex)
      funcIndex = result.funcIndex
      featIndex = result.featIndex
      feat = list[featIndex]
    }
    if (feat) {
      func = feat.functions[funcIndex]
    }
    selectItem = func
  }
  return {
    feat,
    func,
    selectItem,
    featIndex,
    funcIndex
  }
}

export const left = (list, featIndex, funcIndex) => {
  let feat = list[featIndex]
  let func = list[featIndex].functions[funcIndex]
  let selectItem = {}
  if (featIndex !== -1) {
    feat = list[featIndex]
  }
  func = null
  funcIndex = -1
  selectItem = feat
  return {
    feat,
    func,
    selectItem,
    funcIndex,
    featIndex
  }
}
export const right = (list, featIndex, funcIndex) => {
  let feat = list[featIndex]
  let func = list[featIndex].functions[funcIndex]
  let selectItem = {}
  if (feat && feat.functions.length) {
    funcIndex = 0
    func = feat.functions[funcIndex]
  }
  selectItem = func
  return {
    feat,
    func,
    selectItem,
    funcIndex,
    featIndex
  }
}
export const forceLoseFocus = function () {
  if (document.activeElement) {
    document.activeElement.blur()
  }
}
export default {
  up, down, right, left, findFunc, forceLoseFocus
}
